import { ChangeEvent, useState, useEffect } from "react";

import { Input } from "@newsela/angelou";

import { TopicsDataQASelector } from "../../Topics.constants";
import { useTaxonomyTagsContext } from "../TaxonomyTags.provider";
import {
  searchContainerCss,
  searchFormContainerCss,
  searchLabelCss,
} from "./SearchTags.styles";

interface ISearchTagsProps {
  onSearch: (query: string) => void;
}

export const SearchTags = ({ onSearch }: ISearchTagsProps) => {
  const [touched, setTouched] = useState(false);
  const { searchQuery, setSearchQuery } = useTaxonomyTagsContext();
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const { isTabletOrMobileView } = useTaxonomyTagsContext();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
  };

  const handleTouch = () => {
    if (!touched) setTouched(true);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    onSearch(debouncedQuery);
  }, [debouncedQuery, onSearch]);

  return (
    <form css={searchFormContainerCss(isTabletOrMobileView)}>
      <Input
        label="Search Tags"
        inputType={Input.inputTypes.text}
        name="searchTags"
        onChange={handleChange}
        value={searchQuery}
        placeholder="Search"
        onBlur={handleTouch}
        underInputId="search-tags-field"
        __cssFor={{
          root: searchContainerCss,
          label: searchLabelCss,
        }}
        dataProps={{
          "data-qa-selector": TopicsDataQASelector.SEARCH_TAXONOMY,
          "data-testid": "search-taxonomy-modal",
        }}
      />
    </form>
  );
};
